import React from 'react';
import PropTypes from 'prop-types';
import RecentActivities from './RecentActivities';

function DashboardActivities(props) {
  const { artistId } = props;
  return (
    <div className="dashboard-content-activities">
      <RecentActivities
        artistId={artistId}
      />
    </div>
  );
}

DashboardActivities.propTypes = {
  artistId: PropTypes.string.isRequired,
};

export default DashboardActivities;
